module.exports = {
          srcSet: __webpack_public_path__ + "public/images/e4d958a8e328a2df3d2635891648df04-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/e4d958a8e328a2df3d2635891648df04-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/e4d958a8e328a2df3d2635891648df04-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/e4d958a8e328a2df3d2635891648df04-1774.webp"},
          
          width: 1774,
          height: 887
        }